import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import { baseURL } from "../../constants/pathnames";
import Table from "../Table/Table";
import RadioButton from "../RadioButton/RadioButton";
import moment from "jalali-moment";
import ModalProductDetail from "../Requests/ModalRequestDetail";
import { useSelector } from "react-redux";

const UserReqs = ({ userid }) => {
  const { token } = useSelector((state) => state.users);
  // const history = useHistory();
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const filtersRadioButtonData = [
    { value: 3, label: "فقط در انتظار پذیرش" },
    { value: 0, label: "فقط پذیرش شده" },
    { value: 1, label: "فقط لغو شده" },
  ];
  const [isModalProductDetail, setIsModalProductDetail] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [data, setData] = useState([]);
  const [next, setNext] = useState("");
  const [filter, setFilter] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: "عنوان", accessor: "title" },
    { Header: "ارسال کننده درخواست", accessor: "sender" },
    { Header: "دریافت کننده درخواست", accessor: "receiver" },
    { Header: "کد آگهی", accessor: "code" },
    { Header: "تاریخ", accessor: "date" },
    { Header: "وضعیت", accessor: "status" },
    { Header: "جزییات", accessor: "detail" },
  ];

  const getData = useCallback(() => {
    debugger;
    axios
      .get(
        `${baseURL}product/panel/user/suggest/${userid}/${
          filter !== null ? "?offer_status=" + filter : ""
        }`,
        header
      )
      .then((res) => {
        console.log(res.data);
        setData(res.data.results);
        setNext(res.data.next);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [userid, header, filter]);
  useEffect(() => {
    getData();
  }, [getData]);
  const getNextList = () => {
    debugger;
    if (next != null) {
      axios
        .get(next, header)
        .then((res) => {
          console.log("res", res.data);
          setData([...data, ...res.data.results]);
          setNext(res.data.next);
        })
        .catch((err) => {
          console.log("err", err.response);
        });
    }
  };

  useEffect(() => {
    debugger;
    // console.log(state);
    const newArray = [];
    for (let i = 0; i < data?.length; i++) {
      const tr = data[i];
      newArray.push({
        title: tr?.original_product,
        sender: tr?.offer_product_user,
        receiver: tr?.original_product_user,
        code: tr?.id,
        date: moment(tr?.created_time).locale("fa").format("YYYY/MM/DD"),
        status:
          tr?.offer_status === 3 ? (
            <div className='color-yellow'>در انتظار تایید</div>
          ) : tr?.offer_status === 0 ? (
            <div className='color-green2'>تایید شده</div>
          ) : tr?.offer_status === 1 ? (
            <div className='color-red'>لغو شده</div>
          ) : tr?.offer_status === 2 ? (
            <div className='color-green'>مبادله شده</div>
          ) : (
            ""
          ),
        detail: (
          <>
            <img
              className='mx-auto cursor-pointer'
              src='/statics/images/eye.png'
              width='20'
              alt='eye'
              onClick={() => {
                setModalData(tr.id);
                setIsModalProductDetail(true);
              }}
            />
          </>
        ),
      });
    }

    setRows(newArray);
  }, [data]);

  return (
    <>
      <div className='my-10 shadow rounded-xl overflow-x-hidden mx-1 p-1'>
        <div className='flex justify-between items-center mx-3 py-5'>
          <div className='text-xl font-semibold mr-5'>درخواست های ثبت شده</div>
          {/* filter */}
          <div className='relative m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center'>
            <img
              className=''
              src='/statics/images/filter.svg'
              width='16'
              alt='filter'
              onClick={() => setShowFilter(!showFilter)}
              // onMouseOver={() => setShowFilter(true)}
              // onMouseLeave={() => setShowFilter(false)}
            />
            {showFilter && (
              <div
                className='absolute top-10 left-0 min-w-max'
                style={{
                  zIndex: "100000",
                }}
              >
                <div className='rounded-lg shadow p-3 bg-white min-w-max'>
                  <RadioButton
                    data={filtersRadioButtonData}
                    // color='#373636'
                    // backgroundColor='#932b76'
                    // width='80%'
                    change={(value) => {
                      setFilter(value);
                    }}
                    column
                    fontSize='12px'
                    checkedValue={filter}
                    // error={originalityError}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <InfiniteScroll
          className='w-100'
          dataLength={data?.length}
          next={() => getNextList()}
          hasMore={true}
          loader={
            next ? (
              <div className='mx-auto w-max color-blue'>در حال جستجو...</div>
            ) : (
              ""
            )
          }
          scrollableTarget='scrollableDiv'
        >
          <div
            className='overflow-y-scroll scroll-style px-2 ltr h-full'
            id='scrollableDiv'
            style={{ maxHeight: "70vh", minHeight: "20vh" }}
          >
            <div className='rtl m-5 md:m-0'>
              <Table
                classs='paneltable UsersTable'
                columns={columns}
                data={rows}
                hasSpace
              />
            </div>
          </div>
        </InfiniteScroll>
      </div>

      {isModalProductDetail && (
        <ModalProductDetail
          onCancel={() => setIsModalProductDetail(!isModalProductDetail)}
          id={modalData}
          getdata={getData}
        />
      )}
    </>
  );
};

export default UserReqs;
